import React, { useState, useRef } from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Button,
  Input,
  IconButton,
  Tag,
  TagLabel,
  TagCloseButton,
} from '@chakra-ui/react';
import { AttachmentIcon } from '@chakra-ui/icons';

const MicIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <line x1="12" x2="12" y1="19" y2="22"/>
  </svg>
);

const ChatTab = ({ task }) => {
  const [message, setMessage] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const fileInputRef = useRef(null);

  const handleSend = () => {
    if (message.trim() || attachments.length > 0) {
      setMessage('');
      setAttachments([]);
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map(file => ({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + ' KB',
      id: Math.random().toString(36)
    }));
    setAttachments([...attachments, ...newAttachments]);
  };

  return (
    <VStack spacing={0} h="450px" bg="gray.50" borderRadius="md">
      <Box flex="1" w="100%" overflowY="auto" p={4}>
        <VStack spacing={3} align="stretch">
          <HStack align="start">
            <Box bg="white" px={3} py={2} borderRadius="md" boxShadow="sm" maxW="70%">
              <Text fontSize="sm" fontWeight="bold">{task?.assignee?.name || 'Team'}</Text>
              <Text fontSize="sm">Hey, have you updated the task?</Text>
            </Box>
          </HStack>
          <HStack justify="flex-end">
            <Box bg="blue.100" px={3} py={2} borderRadius="md" maxW="70%">
              <Text fontSize="sm" fontWeight="bold">You</Text>
              <Text fontSize="sm">Yes, it's done!</Text>
            </Box>
          </HStack>
        </VStack>
      </Box>

      {attachments.length > 0 && (
        <HStack px={4} py={2} flexWrap="wrap" w="100%">
          {attachments.map((att) => (
            <Tag key={att.id} size="sm" colorScheme="blue">
              <TagLabel fontSize="xs">{att.name} ({att.size})</TagLabel>
              <TagCloseButton onClick={() => setAttachments(attachments.filter(a => a.id !== att.id))} />
            </Tag>
          ))}
        </HStack>
      )}

      <HStack p={4} w="100%" bg="white" borderTop="1px" borderColor="gray.200">
        <input ref={fileInputRef} type="file" multiple hidden onChange={handleFileSelect} />
        <IconButton
          icon={<AttachmentIcon />}
          size="sm"
          onClick={() => fileInputRef.current?.click()}
        />
        <Input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSend()}
          placeholder="Type a message..."
          size="sm"
        />
        <IconButton
          icon={<MicIcon />}
          size="sm"
          onClick={() => setIsRecording(!isRecording)}
          colorScheme={isRecording ? 'red' : 'gray'}
        />
        <Button onClick={handleSend} colorScheme="blue" size="sm">Send</Button>
      </HStack>
    </VStack>
  );
};

export default ChatTab;